import { render, staticRenderFns } from "./main-product.vue?vue&type=template&id=39b717a7&scoped=true&"
import script from "./main-product.vue?vue&type=script&lang=js&"
export * from "./main-product.vue?vue&type=script&lang=js&"
import style0 from "./main-product.vue?vue&type=style&index=0&id=39b717a7&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39b717a7",
  null
  
)

export default component.exports